import { createIcon } from './create-icon'

export const ChevronDownO = createIcon({
  displayName: 'ChevronDownO',
  paths: [
    'M170.667 512c0 188.203 153.131 341.333 341.333 341.333s341.333-153.131 341.333-341.333c0-188.203-153.131-341.333-341.333-341.333s-341.333 153.131-341.333 341.333zM85.333 512c0-235.648 191.019-426.667 426.667-426.667s426.667 191.019 426.667 426.667c0 235.648-191.019 426.667-426.667 426.667s-426.667-191.019-426.667-426.667zM511.983 520.849l108.203-108.203c16.683-16.64 43.648-16.64 60.331 0 16.683 16.683 16.683 43.691 0 60.373l-138.368 138.325c-16.64 16.64-43.648 16.64-60.331 0l-138.325-138.325c-16.683-16.683-16.683-43.691 0-60.373 16.64-16.64 43.648-16.64 60.331 0l108.16 108.203z'
  ]
})
